import { LoginEffects } from '../login/login.effects';

export const coreEffects = [LoginEffects];
